import { render } from "./StockDeliveryNoteModal.vue?vue&type=template&id=354f75a2&scoped=true"
import script from "./StockDeliveryNoteModal.vue?vue&type=script&lang=js"
export * from "./StockDeliveryNoteModal.vue?vue&type=script&lang=js"

import "./StockDeliveryNoteModal.vue?vue&type=style&index=0&id=354f75a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354f75a2"]])

export default __exports__